import React from 'react';
import { Button } from 'react-daisyui';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import styles from '../../agenda.module.scss';
import { useAgendaContext } from '../../hooks/agenda.hook';
import { useAgendaTemplatesContext } from '../../hooks/agendaTemplateView.hook';
import TemplateModal from './TemplateModal/TemplateModal.component';
import AgendaTemplateRow from './TemplateRow.component';
import TemplateDeleteModal from './TemplateModal/TemplateDeleteModal.tsx';
import { useCalendarContext } from '../Calendar/Calendar.hook.tsx';

export default function Templates(): React.ReactElement {
  const { t } = useTranslation();
  const { currentTemplates } = useAgendaContext();
  const { openTemplateCreationModal, showTemplateModal } =
    useAgendaTemplatesContext();
  const { showDeleteTemplate } = useCalendarContext();

  return (
    <div>
      <p className={styles.TemplateModuleTitle}>
        🥳 {t('agenda/agenda:event-templates')}
      </p>
      <div className={styles.TemplateManagementCard}>
        <div className={styles.TemplateManagementCard__TopSection}>
          <div />
          <p className={styles.TemplateManagementCard__TopSection__Title}>
            {' '}
            {t('agenda/agenda:admin-templates')}
          </p>
          <Button color="primary" onClick={openTemplateCreationModal}>
            Agregar template
          </Button>
        </div>
        <div className={styles.TemplateManagementCard__MiddleSection}>
          <div className="col-span-2">{t('agenda/agenda:template-name')}</div>
          <div>{t('agenda/agenda:event-type')}</div>
          <div>{t('agenda/agenda:origin')}</div>
        </div>
        <div className={styles.BottomPartTemplateManagementCard}>
          {currentTemplates?.map((template) => (
            <AgendaTemplateRow template={template} key={template.id} />
          ))}
        </div>
      </div>
      {showTemplateModal && createPortal(<TemplateModal />, document.body)}
      {showDeleteTemplate &&
        createPortal(<TemplateDeleteModal />, document.body)}
    </div>
  );
}
